import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "../../data";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-header"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 2.2, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-[#12100E]/80 backdrop-blur-2xl border-b border-[#2C2621]" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a href="#top" data-testid="logo-link" className="flex items-center gap-3">
          <img
            src="/logo.jpg"
            alt="Ranchoddas Jivraj & Company"
            className="h-14 w-14 md:h-16 md:w-16 rounded-full object-cover ring-1 ring-[#D49A44]/40"
          />
          <span className="hidden sm:flex flex-col leading-none">
            <span className="font-serif-lux text-xl md:text-2xl tracking-tight text-[#F4EFE6]">
              Ranchoddas Jivraj
            </span>
            <span className="font-sans-lux text-[10px] tracking-[0.35em] uppercase text-[#D49A44]">
              & Co. · Est. 1911
            </span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="font-sans-lux text-xs uppercase tracking-[0.2em] text-[#B0A89D] hover:text-[#D49A44] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-[#F4EFE6]"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <motion.nav
          data-testid="mobile-nav"
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          className="md:hidden bg-[#12100E]/95 backdrop-blur-2xl border-t border-[#2C2621] overflow-hidden"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="font-sans-lux text-sm uppercase tracking-[0.2em] text-[#B0A89D]"
              >
                {l.label}
              </a>
            ))}
          </div>
        </motion.nav>
      )}
    </motion.header>
  );
};
